export enum RecurrenceFrequency {
  Weekly = 7,
  Biweekly = 14,
}
